// import router from '@/router'
const actions = {
    // 向缓存列表中新增缓存视图
    push(context, name) {
        // console.log('push');
        const state = context.state,
            // 缓存列表
            keepIncluded = state.keepIncluded;
        // 如果视图不在排除列表中，并且还没有被缓存，添加到缓存列表
        // console.log('缓存页面:', name);
        if (!keepIncluded.includes(name)) {
            keepIncluded.push(name);
        }
    },
    // 移除指定缓存页面
    pop(context, name) {
        const state = context.state,
            // 缓存数组
            keepIncluded = state.keepIncluded,
            // 获取当前视图在缓存目录中的位置
            index = keepIncluded.indexOf(name);
        // console.log('退出当前页面', name)
        // console.log('页面当前缓存位置', index)
        if (index > -1) {
            keepIncluded.splice(index, 1);
        }
    },
    // 从缓存数组中移除除了始终缓存页面之外的所有页面
    removeAll(context) {
        const state = context.state,
            // 始终缓存页面的序号
            index = state.alwaysKeepIncluded.length - 1,
            // 缓存数组
            keepIncluded = state.keepIncluded;
        //   缓存数组最后一项的序号
        let i = keepIncluded.length - 1;
        for (; i > index; i--) {
            keepIncluded.pop();
        }
    }
}
export default actions